import React from "react";

function AddressButton({
  isAddressLoading,
  selectedAddress,
  handleOpenAddressModal,
}) {
  let buttonContent = "Select";

  if (isAddressLoading) {
    buttonContent = <span className="spinner"></span>;
  } else if (selectedAddress) {
    buttonContent = "Change";
  }

  return (
    <>
      <style>{`
        .change {
          padding: 6px 16px;
          background: radial-gradient(circle at top, #1a2a2a, #0f1a1a, #0a0f0f);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 14px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          height: 38px;
        }

        .change:hover {
          background-color: #125aa0;
        }

        .change:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          padding: 8px 16px;
        }

        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid #ccc;
          border-top: 2px solid white;
          border-radius: 50%;
          top: 0px;
          animation: spin 0.8s linear infinite;
          display: inline-block;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <button
        className="change"
        onClick={handleOpenAddressModal}
        type="button"
        disabled={isAddressLoading}
      >
        {buttonContent}
      </button>
    </>
  );
}

export default AddressButton;
